import React, { useEffect, useState } from "react";
import GetUser from "../../components/api/GetUser";
import { Avatar, Box, Divider, Typography } from "@mui/material";
import Cookies from "js-cookie";

const User = () => {
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const authKey = Cookies.get('skyarc-auth-8080');
                const response = await GetUser(authKey);
                setUserData(response.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);

    return (
        <Box sx={{ m: '18px', maxWidth: '100%', height: '100%' }}>
            {
                userData !== undefined ? (
                    <Box sx={{display:'flex', justifyContent:'center', height:'100%', marginTop:'70px'}}>
                        <Box sx={{width:'50%', height:'30%',minHeight:'370px', minWidth:'470px', backgroundColor:'#f2f0f0', boxShadow:'3', padding:'18px'}}>
                           <Box sx={{width:'75px', height:'75px'}}>
                            <Avatar sx={{width:'100%', height:'100%', fontSize:'30px'}}>{userData['rows'][0].dis.charAt(0)}</Avatar>
                           </Box>
                           <Box sx={{width:'100%', marginTop:'18px'}}>
                             <Typography variant="h5" fontWeight='bold'>{userData['rows'][0].dis}</Typography>
                           </Box>
                           <Divider sx={{marginTop:'18px'}}/>
                           <Box sx={{width:'100%', height:'100%', marginTop:'18px', display:'flex'}}>
                            <Box sx={{width:{xl:'17%', lg:'20%', md:'25%', sm:'25%'}}}>
                                <Typography fontWeight='400' sx={{fontSize:{xl:'16px', lg:'13px'}}}>E-mail:</Typography>
                                <Typography fontWeight='400' sx={{fontSize:{xl:'16px', lg:'13px'}}}>Gebruikersnaam</Typography>
                                <Typography fontWeight='400' sx={{fontSize:{xl:'16px', lg:'13px'}}}>Aanmaakdatum:</Typography>
                                <Typography fontWeight='400' sx={{fontSize:{xl:'16px', lg:'13px'}}}>Beschikbare tabs:</Typography>
                            </Box>
                            <Box sx={{width:{xl:'83%', lg:'80%', md:'75%', sm:'75%'}}}>
                                <Typography fontWeight='400' sx={{fontSize:{xl:'16px', lg:'13px'}}}>{userData['rows'][0].email}</Typography>
                                <Typography fontWeight='400' sx={{fontSize:{xl:'16px', lg:'13px'}}}>{userData['rows'][0]['id']['val'].replace('u:', '')}</Typography>
                                <Typography fontWeight='400' sx={{fontSize:{xl:'16px', lg:'13px'}}}>{userData['rows'][0].created.val}</Typography>
                                <Typography fontWeight='400' sx={{fontSize:{xl:'16px', lg:'13px'}}}>{userData['rows'][0].infSiteModules.map((tab) => tab + ', ')}</Typography>
                            </Box>
                           </Box>
                        </Box>
                    </Box>
                ) : (
                    <></>
                )
            }
        </Box>
    )
}

export default User;
